import { Routes } from '@angular/router';
import { authGuard } from '@shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/modules.routes').then((m) => m.MODULE_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./shared/components/auth-manager/auth-manager.component').then(
        (m) => m.AuthManagerComponent
      ),
  },
];
